import map from 'lodash/map';
import filter from 'lodash/filter';
import round from 'lodash/round';

export default {
  data() {
    return {
      optionsHeatMapBubble: {
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        // showBubbleLabels: true,
        showBubbleLabels: false,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'COMMENT APPLAUSE',
                fontSize: 9,
              },
              ticks: {
                min: 0,
                stepSize: 5,
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'COMMENTS MADE',
                fontSize: 9,
              },
              ticks: {
                min: 0,
                stepSize: 5,
                beginAtZero: true,
              },
            },
          ],
        },
        hover: {
          mode: 'point',
          animationDuration: 400,
        },
        tooltips: {
          xPadding: 10,
          enabled: true,
          displayColors: false,
          callbacks: {
            title: (tooltipItems, data) => {
              const sameStatObjects = filter(
                data.datasets,
                (dataset) =>
                  dataset.data[0].x === tooltipItems[0].xLabel &&
                  dataset.data[0].y === tooltipItems[0].yLabel
              );
              const titles = map(sameStatObjects, (obj) => obj.label);
              return titles;
            },
            label: (tooltipItems) => {
              const spoke = `Comments Made: ${round(tooltipItems.xLabel, 1)}`;
              const points = `Comment Applause: ${round(
                tooltipItems.yLabel,
                1
              )}`;
              return [spoke, points];
            },
          },
        },
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/onlineBubbleOptions.js